export default "__VITE_ASSET__vpu2PfwA__"